import React, { useContext } from "react";
import PlatformContext from "./PlatformContext.jsx";

export default function AddPhotosButton() {
  const { platform } = useContext(PlatformContext);
  const previewFontClass = platform === "ios" ? "tw-font-previewIos tw-tracking-wide" : "tw-font-previewAndroid";

  return (
    <button
      className={`
        ${previewFontClass}
        tw-appearance-none
        tw-border-0
        tw-bg-transparent
        tw-p-0
        tw-text-sm
        tw-font-medium
      `}
    >
      Add Photos
    </button>
  );
}
